import type {
  MailerSettingsDto,
  MailerSettingsRequest,
  MailerTestResponse,
  NotificationLogItem,
} from '@expeditor/shared';
import { apiClient } from './client';

export const mailerApi = {
  async getSettings(): Promise<MailerSettingsDto> {
    const { data } = await apiClient.get<MailerSettingsDto>('/admin/mailer/settings');
    return data;
  },
  async updateSettings(dto: MailerSettingsRequest): Promise<MailerSettingsDto> {
    const { data } = await apiClient.put<MailerSettingsDto>('/admin/mailer/settings', dto);
    return data;
  },
  async sendTest(to: string): Promise<MailerTestResponse> {
    const { data } = await apiClient.post<MailerTestResponse>('/admin/mailer/test', { to });
    return data;
  },
  async log(params: {
    status?: 'QUEUED' | 'SENT' | 'FAILED' | 'READ';
    search?: string;
    limit?: number;
  } = {}): Promise<NotificationLogItem[]> {
    const q: Record<string, string> = {};
    if (params.status) q.status = params.status;
    if (params.search) q.search = params.search;
    if (params.limit) q.limit = String(params.limit);
    const { data } = await apiClient.get<NotificationLogItem[]>('/admin/mailer/log', {
      params: q,
    });
    return data;
  },
};
